import axios from "axios";
const apiRc = axios.create({
    //baseURL : 'http://localhost:3002/rc-api'
    baseURL : 'https://api-rc.codiceinnova.com/rc-api'
})

export default apiRc
